import ReportDetail from "@/views/common/ReportDetail.vue"

export const reportdetail = {
  path: '/reportdetail/:id',
  name: 'ReportDetail',
  component: ReportDetail
}




// WEBPACK FOOTER //
// ./src/router/index/common/index.js